import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import {environment} from "../../../../../../environments/environment";

@Component({
  selector: 'kt-campaign-notice',
  templateUrl: './campaign-notice.component.html',
  styleUrls: ['../notice/notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignNoticeComponent implements OnInit {

  @Input() zoneAlert = false;
  hidden: boolean = true;

  constructor() { }

  ngOnInit() {
  }

}
